import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { useUserSettingsSitesGroup, useUserSettingsSitesGroupValidator} from "../../@hooks"


export default function UserSettingSitesGroupDrawerSubmit() {
    const { isLoading, handleSubmitSitesGroupFormData } = useUserSettingsSitesGroup()
    const { isValid } = useUserSettingsSitesGroupValidator()

    return <ButtonLoadingSeeker
        loading={isLoading}
        disabled={!isValid}
        onClick={handleSubmitSitesGroupFormData}
    >
        Save
    </ButtonLoadingSeeker>
}